import PropTypes from 'prop-types';
import React from 'react';
import {useSignIn} from '../../hooks/useSignIn';

const SignUp = ({
        isLoggedIn,
        ctaString,
        returnUrl,
        history
    }) => {
    const signIn = useSignIn(isLoggedIn, returnUrl, history)

    return (
        <>
            <button onClick={signIn} className="btn btn-primary">
                <span>{ctaString}</span>
            </button>
        </>
    );
};

SignUp.propTypes = {
    returnUrl: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
    ctaString: PropTypes.string
}

export default SignUp;
